import { Component } from '@angular/core';
import { DOCS_ENDPOINTS, DOCS_SCHEMAS } from '../../data/docs-api-data';

/**
 * API reference index (/docs/api-reference) the endpoint list, one card
 * per endpoint linking to its own page (see ../detail/docs-api-reference-detail
 * for what's there, routed at /docs/api-reference/:id). Adding a fourth
 * endpoint to DOCS_ENDPOINTS is all this page needs to pick it up.
 */
@Component({
  selector: 'app-docs-api-reference-index',
  standalone: false,
  templateUrl: './docs-api-reference-index.html',
})
export class DocsApiReferenceIndex {
  readonly endpoints = DOCS_ENDPOINTS;
  readonly schemaCount = DOCS_SCHEMAS.length;
}
